export const formatCurrency = ({
  value = 0,
  locale,
  currency,
  removeDecimalsIfWhole,
  maximumFractionDigits = 2,
}: FormatCurrencyArgs): string => {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency,
    currencyDisplay: currency === "USD" ? "code" : "symbol",
    maximumFractionDigits,
    minimumFractionDigits: maximumFractionDigits,
  };

  // Round the value up to the maximum number of fraction digits
  const roundedValue = Math.round(value * Math.pow(10, maximumFractionDigits)) / Math.pow(10, maximumFractionDigits);

  /**
   * This handles multiplied float values in JavaScript, such as
   * 3.00000000000001, 175.00000000000003, 734.9999999999999
   */
  const isValueWhole = Math.abs(roundedValue - Math.round(roundedValue)) <= Number.EPSILON;

  if (removeDecimalsIfWhole === true && isValueWhole === true) {
    options.maximumFractionDigits = 0;
    options.minimumFractionDigits = 0;
  }

  return new globalThis.Intl.NumberFormat(locale, options).format(roundedValue);
};

type FormatCurrencyArgs = {
  value?: number;
  locale: string;
  currency: string;
  removeDecimalsIfWhole?: boolean;
  maximumFractionDigits?: number;
};
